import "./style.css";
import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { c as _ } from "../../__shared__/index.js";
const c = "_wrapper_1gw6l_1", d = "_text_1gw6l_12", i = "_primary_1gw6l_19", n = "_secondary_1gw6l_26", r = {
  wrapper: c,
  text: d,
  primary: i,
  secondary: n,
  default: "_default_1gw6l_33"
}, o = {
  primary: r.primary,
  secondary: r.secondary,
  default: r.default
};
function u({ text: s, variant: l = "default", Icon: a, iconAdornment: e = "left" }) {
  return /* @__PURE__ */ p("div", { className: _(
    r.wrapper,
    o[l] ?? r.default
  ), children: [
    a && e === "left" && /* @__PURE__ */ t(a, {}),
    /* @__PURE__ */ t("span", { className: r.text, children: s }),
    a && e === "right" && /* @__PURE__ */ t(a, {})
  ] });
}
export {
  u as default
};
//# sourceMappingURL=SavingTag.js.map
